module.exports = __webpack_public_path__ + "static/media/fabricio_galende.211fa80e.png";